import { QueryKeys } from '../../../enums/queryKeys'

export const zervantSettingsQueryKey = [QueryKeys.ZervantSettings]
